// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v6.33.5
// source: roboverse_platform_protos/statekeeping/Config/Session.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "roboverse_platform_protos.statekeeping.Config";

export interface Session {
  /** defined by the user on FE */
  friendlyName: string;
  /** Session id (UUID) that is used for aggregrating all the data collected by spot with respect */
  uniqueSessionId: string;
  /**
   * to a single session. This is the only session id we care of when it comes to
   * data acquisition
   */
  startAtUtc:
    | Date
    | undefined;
  /** At any given instance, there can always be a uniqueSessionId which can be */
  teleoperationSession:
    | Session_TeleoperationSession
    | undefined;
  /** tied to either teleoperationSession or missionSession, but never both, this */
  missionSession: Session_MissionSession | undefined;
}

/** TeleoperationSession would be tied to when the user creates a session */
export interface Session_TeleoperationSession {
  /** from the FE, the teleoperationSessionId is set by the BE. */
  operatorName: string;
  /** At the moment, the robot side of the code, doesnt care for this yet */
  teleoperationSessionId: number;
}

/** MissionSession would be tied to when executing a mission, this is set by the BE */
export interface Session_MissionSession {
  /** and we fetch this on the robot side to close the missions sessions in the */
  missionPlanId: number;
  /** MissionExecutorInterface. */
  missionSessionId: number;
}

function createBaseSession(): Session {
  return {
    friendlyName: "",
    uniqueSessionId: "",
    startAtUtc: undefined,
    teleoperationSession: undefined,
    missionSession: undefined,
  };
}

export const Session: MessageFns<Session> = {
  encode(message: Session, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.friendlyName !== "") {
      writer.uint32(10).string(message.friendlyName);
    }
    if (message.uniqueSessionId !== "") {
      writer.uint32(18).string(message.uniqueSessionId);
    }
    if (message.startAtUtc !== undefined) {
      Timestamp.encode(toTimestamp(message.startAtUtc), writer.uint32(26).fork()).join();
    }
    if (message.teleoperationSession !== undefined) {
      Session_TeleoperationSession.encode(message.teleoperationSession, writer.uint32(34).fork()).join();
    }
    if (message.missionSession !== undefined) {
      Session_MissionSession.encode(message.missionSession, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Session {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.friendlyName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.uniqueSessionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.startAtUtc = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.teleoperationSession = Session_TeleoperationSession.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.missionSession = Session_MissionSession.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Session {
    return {
      friendlyName: isSet(object.friendlyName) ? globalThis.String(object.friendlyName) : "",
      uniqueSessionId: isSet(object.uniqueSessionId) ? globalThis.String(object.uniqueSessionId) : "",
      startAtUtc: isSet(object.startAtUtc) ? fromJsonTimestamp(object.startAtUtc) : undefined,
      teleoperationSession: isSet(object.teleoperationSession)
        ? Session_TeleoperationSession.fromJSON(object.teleoperationSession)
        : undefined,
      missionSession: isSet(object.missionSession) ? Session_MissionSession.fromJSON(object.missionSession) : undefined,
    };
  },

  toJSON(message: Session): unknown {
    const obj: any = {};
    if (message.friendlyName !== "") {
      obj.friendlyName = message.friendlyName;
    }
    if (message.uniqueSessionId !== "") {
      obj.uniqueSessionId = message.uniqueSessionId;
    }
    if (message.startAtUtc !== undefined) {
      obj.startAtUtc = message.startAtUtc.toISOString();
    }
    if (message.teleoperationSession !== undefined) {
      obj.teleoperationSession = Session_TeleoperationSession.toJSON(message.teleoperationSession);
    }
    if (message.missionSession !== undefined) {
      obj.missionSession = Session_MissionSession.toJSON(message.missionSession);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Session>, I>>(base?: I): Session {
    return Session.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Session>, I>>(object: I): Session {
    const message = createBaseSession();
    message.friendlyName = object.friendlyName ?? "";
    message.uniqueSessionId = object.uniqueSessionId ?? "";
    message.startAtUtc = object.startAtUtc ?? undefined;
    message.teleoperationSession = (object.teleoperationSession !== undefined && object.teleoperationSession !== null)
      ? Session_TeleoperationSession.fromPartial(object.teleoperationSession)
      : undefined;
    message.missionSession = (object.missionSession !== undefined && object.missionSession !== null)
      ? Session_MissionSession.fromPartial(object.missionSession)
      : undefined;
    return message;
  },
};

function createBaseSession_TeleoperationSession(): Session_TeleoperationSession {
  return { operatorName: "", teleoperationSessionId: 0 };
}

export const Session_TeleoperationSession: MessageFns<Session_TeleoperationSession> = {
  encode(message: Session_TeleoperationSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.operatorName !== "") {
      writer.uint32(10).string(message.operatorName);
    }
    if (message.teleoperationSessionId !== 0) {
      writer.uint32(16).int32(message.teleoperationSessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Session_TeleoperationSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSession_TeleoperationSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.operatorName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.teleoperationSessionId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Session_TeleoperationSession {
    return {
      operatorName: isSet(object.operatorName) ? globalThis.String(object.operatorName) : "",
      teleoperationSessionId: isSet(object.teleoperationSessionId)
        ? globalThis.Number(object.teleoperationSessionId)
        : 0,
    };
  },

  toJSON(message: Session_TeleoperationSession): unknown {
    const obj: any = {};
    if (message.operatorName !== "") {
      obj.operatorName = message.operatorName;
    }
    if (message.teleoperationSessionId !== 0) {
      obj.teleoperationSessionId = Math.round(message.teleoperationSessionId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Session_TeleoperationSession>, I>>(base?: I): Session_TeleoperationSession {
    return Session_TeleoperationSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Session_TeleoperationSession>, I>>(object: I): Session_TeleoperationSession {
    const message = createBaseSession_TeleoperationSession();
    message.operatorName = object.operatorName ?? "";
    message.teleoperationSessionId = object.teleoperationSessionId ?? 0;
    return message;
  },
};

function createBaseSession_MissionSession(): Session_MissionSession {
  return { missionPlanId: 0, missionSessionId: 0 };
}

export const Session_MissionSession: MessageFns<Session_MissionSession> = {
  encode(message: Session_MissionSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.missionPlanId !== 0) {
      writer.uint32(8).int32(message.missionPlanId);
    }
    if (message.missionSessionId !== 0) {
      writer.uint32(16).int32(message.missionSessionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Session_MissionSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSession_MissionSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.missionPlanId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.missionSessionId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Session_MissionSession {
    return {
      missionPlanId: isSet(object.missionPlanId) ? globalThis.Number(object.missionPlanId) : 0,
      missionSessionId: isSet(object.missionSessionId) ? globalThis.Number(object.missionSessionId) : 0,
    };
  },

  toJSON(message: Session_MissionSession): unknown {
    const obj: any = {};
    if (message.missionPlanId !== 0) {
      obj.missionPlanId = Math.round(message.missionPlanId);
    }
    if (message.missionSessionId !== 0) {
      obj.missionSessionId = Math.round(message.missionSessionId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Session_MissionSession>, I>>(base?: I): Session_MissionSession {
    return Session_MissionSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Session_MissionSession>, I>>(object: I): Session_MissionSession {
    const message = createBaseSession_MissionSession();
    message.missionPlanId = object.missionPlanId ?? 0;
    message.missionSessionId = object.missionSessionId ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
